import { render } from "./FoodHygieneModal.vue?vue&type=template&id=534f0719"
import script from "./FoodHygieneModal.vue?vue&type=script&lang=js"
export * from "./FoodHygieneModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__